// extracted by mini-css-extract-plugin
module.exports = {"chat":"CreateGroupChat_chat__UaqUi","createButtonContainer":"CreateGroupChat_createButtonContainer__1G2DO"};